// extracted by mini-css-extract-plugin
export default {"Solutionimage":"solution_Solutionimage__4OEiE"};